import { Link } from 'react-router-dom';
import { MessageSquare, Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useNotifications } from '@/hooks/useNotifications';
import { useChats } from '@/hooks/useChats';
import { useMembership } from '@/contexts/MembershipContext';

export function CommunicationBadge() {
  const { unreadCount: notificationUnread } = useNotifications();
  const { totalUnreadCount: chatUnread } = useChats();
  const { capabilities } = useMembership();

  // Show for all tiers that can receive notifications
  if (!capabilities.canReceiveNotifications) {
    return null;
  }

  const totalUnread = notificationUnread + chatUnread;
  const canUseChat = capabilities.canSendNotifications; // Connector tier only

  // Non-Connector users see a limited indicator
  if (!canUseChat) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="ghost" size="icon" className="relative" asChild>
            <Link to="/communication">
              <MessageSquare className="h-5 w-5" />
              {/* Limited feature indicator */}
              <span className="absolute -bottom-0.5 -right-0.5 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-muted border border-border">
                <Lock className="h-2 w-2 text-muted-foreground" />
              </span>
              {totalUnread > 0 && (
                <span className="absolute -top-0.5 -right-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-medium text-destructive-foreground">
                  {totalUnread > 99 ? '99+' : totalUnread}
                </span>
              )}
            </Link>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Upgrade to Connector to unlock chat</p>
        </TooltipContent>
      </Tooltip>
    );
  }

  return (
    <Button variant="ghost" size="icon" className="relative" asChild>
      <Link to="/communication">
        <MessageSquare className="h-5 w-5" />
        {totalUnread > 0 && (
          <span className="absolute -top-0.5 -right-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-medium text-destructive-foreground">
            {totalUnread > 99 ? '99+' : totalUnread}
          </span>
        )}
      </Link>
    </Button>
  );
}
